/**
 * Author: Satyam Sharma
 * Date: 25 Jan 2025
 * Description:
 * This component, ImagePreview, is responsible for displaying an image preview with zoom functionality. 
 * This image preview works for AI response only.
 * Props:
 * - isActive: boolean indicating if the preview is active
 * - src: string URL of the image to be previewed
 * State:
 * - imageScale: number representing the scale of the image for zoom functionality
 * Functions:
 * - setStateAsInactive: sets the image preview state as inactive if the event target is not a button
 * - handleZoomIn: increases the image scale for zooming in
 * - handleZoomOut: descreases the image scale for zooming out
 * - handleDownload: open the image in a new tab and makes it available for download
 */

import { useDispatch, useSelector } from "react-redux";
import { updateEnvironment } from "../../../actions/environment.action";
import { useState } from "react";

export default function ImagePreview(props: { isActive: boolean; src: string }) {
  const { src } = props;

  const environment = useSelector(((state: any) => state.environment));
  const [imageScale, setImageScale] = useState(1);
  const dispatch = useDispatch();

  const setStateAsInactive = (e: any) => {
    if (!e.target.closest('button')) {
      dispatch(updateEnvironment({ imagePreview: {} }));
    }
  }

  const handleZoomIn = (e: any) => {
    e.preventDefault();
    setImageScale(imageScale + 0.4);
  };


  const handleZoomOut = (e: any) => {
    e.preventDefault();
    setImageScale(imageScale - 0.4);
    if (imageScale < 1) {
      setImageScale(1);
    }
  };

  const resetImageScale = (e: any) => {
    e.preventDefault();
    if (imageScale > 1 ) {
      setImageScale(1);
    }
  }

  const handleDownload = () => {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.setAttribute('target', '_blank');
    a.href = src;
    a.download = src.split('/').pop() as string;
    a.click();
    window.URL.revokeObjectURL(src);
    a.remove();
  }

  return (
    <div id="400" className={`absolute ${environment?.direction === 'rtl' ? 'right-0' : 'left-0'} top-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 transition-opacity duration-300 overflow-hidden`}
      onClick={setStateAsInactive}>
      <img src={src} alt="markdown-img" className="max-w-80 max-h-80 transition-transform duration-300" style={{
        transform: `scale(${imageScale})`,
        transition: 'transform 0.5s ease-in-out',
      }}></img>

      <div id="401" className={`flex justify-center items-center absolute bottom-0 ${environment?.direction === 'rtl' ? 'right-0' : 'left-0'} w-full mb-4`}>
        <div id="403" className="bg-bpDarkCharcoal rounded-bpBorder20 p-bpPadding5">
          <button id="404" className="text-white mx-2" onClick={handleZoomOut}>
            <img
              src={process.env.REACT_APP_CDN + '/remove.svg'}
              alt="zoom-out-image"
              className="inline-block zoom-out mr-2"
            />
          </button>
          <button id="408" className="text-white" onClick={resetImageScale}>
            <img 
              id="409" 
              src={process.env.REACT_APP_CDN + '/zoom_out.svg'}
              alt="handle-iamge"
              className="inline-block cursor-pointer"
            />
           </button>
          <button id="406" className="text-white mx-2" onClick={handleZoomIn}>
            <img
              src={process.env.REACT_APP_CDN + '/add.svg'}
              alt="zoom-in"
              className="inline-block zoom-in ml-2"
            />
          </button>
        </div>

      </div>

      <div id="402" className="absolute bottom-0 right-0 mr-4 mb-4  ">
        <button id="407"  className="text-white bg-bpDarkCharcoal p-bpPadding10 rounded-bpBorder50 flex justify-center items-center" onClick={handleDownload} style={{ height: "36px",  width: "36px"}}>
          <img
            src={process.env.REACT_APP_CDN + '/download.svg'}
            alt="download-image"
            className="inline-block"
          />
        </button>
      </div>
    </div>
  )
}
